<template>
  <div class="my-3">
    <el-form
      ref="user"
      :model="user"
      :rules="rules"
      label-position="left"
      label-width="auto"
      style="max-width: 800px"
      class="mx-auto"
    >
      <div class="mt-4">
        <el-form-item prop="full_name" label="名前">
          <el-input v-model="user.full_name" />
        </el-form-item>
      </div>

      <div class="mt-4">
        <el-form-item prop="email" label="メールアドレス">
          <el-input v-model="user.email" />
        </el-form-item>
      </div>

      <div class="mt-4">
        <el-form-item v-if="!user.id" prop="password" label="パスワード">
          <el-input v-model="user.password" show-password />
        </el-form-item>
      </div>

      <div class="mt-4 mb-10">
        <el-form-item v-if="!user.id" prop="password_confirmation" label="確認用パスワード">
          <el-input v-model="user.password_confirmation" show-password />
        </el-form-item>
      </div>

      <div class="text-center">
        <a href="/users" class="btn btn-outline-primary w-200px me-3">{{ 'キャンセル' }}</a>
        <span v-if="!user.id" class="btn btn-primary w-200px" @click="save()">{{ '登録する' }}</span>
        <span v-else class="btn btn-primary w-200px" @click="save()">{{ '保存する' }}</span>
      </div>
    </el-form>
  </div>
</template>

<script>
import 'babel-polyfill';
import http_method from '../mixins/http_method';
import announce_message from '../mixins/announce_message';
import User from '../classes/user.js';
import axios from 'axios';
import 'element-plus';

export default {
  name: 'userForm',
  components: {},
  data() {
    return {
      user: User.fromObject(),
      loading: false,
      rules: {
        full_name: [
          { max: 200, message: '200字以内で入力してください', trigger: 'blur' },
          { required: true, message: '名前は必須項目です', trigger: 'blur' },
        ],
        email: [
          { max: 200, message: '200字以内で入力してください', trigger: 'blur' },
          {
            required: true,
            message: 'メールアドレスは必須項目です',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'メールアドレスが正しくありません',
            trigger: ['blur', 'change'],
          },
        ],
        password: [
          {
            required: true,
            message: 'パスワードは必須項目です',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (value.match(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9!.?\-~_@]{8,128}$/) == null) {
                callback(new Error('半角英数字(大文字小文字数字をすべて含む)8文字以上128文字以下で入力してください。'));
              } else {
                callback();
              }
            },
          },
        ],
        password_confirmation: [
          {
            required: true,
            message: '確認用パスワードは必須項目です',
            trigger: 'blur',
          },
          { max: 128, message: '128字以内で入力してください', trigger: 'blur' },
          { min: 8, message: '8字以上で入力してください', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.user.password != value) {
                callback(new Error('パスワードが一致しません'));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  props: {
    companies: {
      type: Array,
      default: [],
    },
  },
  mixins: [http_method, announce_message],
  created() {
    this.loading = true;
    this.getUser();
    this.loading = false;
  },
  methods: {
    /**
     * ユーザーレコードの取得
     */
    async getUser() {
      const path_name = location.pathname.split('/');
      const id = path_name[2];
      if (id === 'new') {
        this.user = User.fromObject();
      } else {
        const response = await this.getSelect(
          {},
          `/users/${id}.json`,
          'ユーザー情報の取得に失敗しました。画面を再読み込みしてください。',
        );
        this.user = User.fromObject(response.data);
        console.log(response.data);
      }
    },
    async save() {
      this.loading = true;
      this.$refs.user.validate((valid) => {
        if (valid) {
          if (this.user.id) {
            this.putUpdateUser();
          } else {
            this.postCreateUser();
          }
        } else {
          console.log('error submit!!');
          this.announceMessage('error', '入力内容を確認してください。');
        }
        this.loading = false;
        return false;
      });
    },
    /**
     * 新規登録をPOSTする
     * 成功した場合はユーザー一覧ページへリダイレクトする
     */
    async postCreateUser() {
      const response = await axios.post(`/users.json`, this.user.formatParams()).catch((error) => {
        this.announceMessage('error', error.response.data.message.join('<br>'));
      });
      if (response.data.status == 'error' || response.data.status == 'unprocessable_entity') {
        this.announceMessage('error', '登録に失敗しました。');
      } else {
        location.href = '/users';
      }
    },
    /**
     * 更新をPUTする
     * 成功した場合はユーザー一覧ページへリダイレクトする
     */
    async putUpdateUser() {
      const response = await axios.patch(`/users/${this.user.id}.json`, this.user.formatParams()).catch((error) => {
        console.log(error.response.data);
        this.$message({
          type: 'error',
          dangerouslyUseHTMLString: true,
          message: error.response.data.message.join('<br>'),
        });
      });
      if (response.data.status == 'error' || response.data.status == 'unprocessable_entity') {
        this.announceMessage('error', '更新に失敗しました。');
      } else {
        location.href = '/users';
      }
    },
  },
};
</script>
